export const common = {
  // Navigation
  home: 'Startseite',
  dashboard: 'Dashboard',
  nutritionPlan: 'Ernährungsplan',
  recipes: 'Rezepte',
  shoppingList: 'Einkaufsliste',
  progress: 'Fortschritt',
  profile: 'Profil',
  admin: 'Admin',
  productSettings: 'Produkt-Einstellungen',
  logout: 'Abmelden',

  // Common Actions
  save: 'Speichern',
  saving: 'Wird gespeichert...',
  cancel: 'Abbrechen',
  delete: 'Löschen',
  edit: 'Bearbeiten',
  add: 'Hinzufügen',
  close: 'Schließen',
  back: 'Zurück',
  next: 'Weiter',
  previous: 'Zurück',
  submit: 'Absenden',
  search: 'Suchen',
  filter: 'Filtern',
  sort: 'Sortieren',
  view: 'Ansehen',
  details: 'Details',

  // Common Labels
  email: 'E-Mail',
  password: 'Passwort',
  name: 'Name',
  age: 'Alter',
  gender: 'Geschlecht',
  height: 'Größe',
  weight: 'Gewicht',
  goal: 'Ziel',
  status: 'Status',
  date: 'Datum',
  time: 'Zeit',
  select: 'Wählen',
  month: 'Monat',
  year: 'Jahr',
  important: 'Wichtig',

  // Status
  active: 'Aktiv',
  inactive: 'Inaktiv',
  completed: 'Abgeschlossen',
  pending: 'Ausstehend',

  // Messages
  loading: 'Lädt...',
  noData: 'Keine Daten verfügbar',
  error: 'Ein Fehler ist aufgetreten',
  success: 'Erfolgreich',

  // Units
  kg: 'kg',
  cm: 'cm',
  kcal: 'kcal',
  g: 'g',
  min: 'Min',
  days: 'Tage',
  weeks: 'Wochen',
  months: 'Monate',

  importantNote: 'Wichtiger Hinweis',

  chatbot: {
    modifyNutritionPlan: "Ich möchte meinen Ernährungsplan ändern",
    createNutritionPlan: "Ich möchte meinen Ernährungsplan erstellen",
    changeMealsForDay: "Ich möchte meine Mahlzeiten für Tag {{dayNumber}} ändern",
    modifyPlanPreview: "Ändere {{mealType}} für Tag {{dayNumber}} im neuen {{planTitle}}-Plan",
  },
  retry: 'Erneut versuchen',
  keyTakeaway: 'Kernaussage',

  app: {
    title: "NutriBot - Dein persönlicher Ernährungscoach"
  }
};
